import EvaluateProcessor from "../../../core/internal/evaluation/EvaluateProcessor"
import { InAppMessageEligibilityEvaluation } from "../../../core/internal/evaluation/service/inappmessage/eligibility/InAppMessageEligibilityEvaluation"
import { InAppMessageEligibilityRemoteEvaluateRequest } from "../../../core/internal/evaluation/service/inappmessage/eligibility/mode/remote/InAppMessageEligibilityRemoteEvaluateRequest"
import { TrackEvent } from "../../../core/internal/event/UserEvent"
import { HackleUser } from "../../../core/internal/model/model"
import WorkspaceEvaluation from "../../../core/internal/workspace/evaluation/WorkspaceEvaluation"
import WorkspaceEvaluationFetcher from "../../../core/internal/workspace/evaluation/WorkspaceEvaluationFetcher"
import InAppMessageEligibilityRemoteEvaluateResult from "../../../core/internal/workspace/evaluation/entity/InAppMessageEligibilityRemoteEvaluateResult"
import { InAppMessageEventMatcher } from "./InAppMessageEventMatcher"
import { AbstractInAppMessageTriggerDeterminer } from "./InAppMessageTriggerDeterminer"

export class RemoteInAppMessageTriggerDeterminer extends AbstractInAppMessageTriggerDeterminer<
  WorkspaceEvaluation,
  InAppMessageEligibilityRemoteEvaluateResult
> {
  constructor(
    protected readonly eventMatcher: InAppMessageEventMatcher,
    private readonly workspaceEvaluationFetcher: WorkspaceEvaluationFetcher,
    private readonly evaluateProcessor: EvaluateProcessor
  ) {
    super()
  }

  protected workspace(user: HackleUser): WorkspaceEvaluation | null {
    return this.workspaceEvaluationFetcher.workspace(user)
  }

  protected evaluate(
    workspace: WorkspaceEvaluation,
    message: InAppMessageEligibilityRemoteEvaluateResult,
    event: TrackEvent
  ): InAppMessageEligibilityEvaluation {
    const request = InAppMessageEligibilityRemoteEvaluateRequest.of(
      workspace,
      event.user,
      message,
      "TRIGGER",
      "WEB",
      event.timestamp
    )
    return this.evaluateProcessor.inAppMessageEligibility(request).evaluation
  }
}
